import React from "react";
import { backToPropertyAddress, setFormData } from "../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { flattenObject } from "../../shared/utils"
import CTAButton from "../../../CTAButton";
import BackButton from "../../shared/BackButton";

const NoAvailableWarranty = () => {
  const dispatch = useDispatch();
  const formData = useSelector(state => state.formData)

  const data = {
    viaClaimForm: true,
    propertyClaimedBy: formData.propertyClaimedBy,
    hasContractorInfo: formData.newContractorInfo.firstName ? true : false,
    newContractorInfo: formData.newContractorInfo.firstName ? formData.newContractorInfo : null,
    contractorEmail: formData.contractorEmail
  }

  const flattenedData = flattenObject(data);
  const queryString = Object.keys(flattenedData)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(flattenedData[key]))
    .join('&');

  return (
    <>
      <BackButton
        analytics={{
          "data-track": "form-back",
          "data-track-form-name": "Submit Claim",
          "data-track-form-step": "step 2 - no available warranty"
        }}
        onClick={() => {
          dispatch(setFormData({showNoAvailableWarray: false,}))
          dispatch(backToPropertyAddress())}
        }
        backText={'Please verify the property address'}
      />
      <p>It looks like your warranty has not yet been registered. We'll need to register the warranty before opening your claim.</p>
      <CTAButton
        data-track="form-advance"
        data-track-form-name="Submit Claim"
        data-track-form-step="step 2 - warranty has not yet been registered"
        text="Click Here to Continue"
        href={`/roofing/warranty/register-standard?${queryString}`}
      />
   </>
  )
};

export default NoAvailableWarranty;
